import { TabsProps } from "antd";
import { Insights } from "../Insights";
import { useDeepLinks } from "src/hooks/useDeepLinks";
import { DashboardV1State, DeepLinkType } from "pages/api/deep-links/types";

export function useEntityTabs(props: {
  entity: any;
  history?: JSX.Element;
  others?: {
    name: string;
    component: JSX.Element;
  }[];
}): TabsProps["items"] {
  const others = props.others ? props.others : [];

  const entityName = props.entity.labels[0];
  const dashboards = useDeepLinks(DeepLinkType.BOARD);
  const systemName = `insight-${entityName}`;
  const named = dashboards.links.data?.find(
    (link) => (link.json as DashboardV1State).systemName === systemName
  );
  const hasInsightDashboard = named !== undefined;

  return [
    ...others.map((item, index) => ({
      key: `${item.name}`,
      id: `${item.name}+${index}`,
      label: item.name,
      children: <>{item.component}</>,
    })),
    hasInsightDashboard && {
      key: "overview",
      id: "overview",
      label: "Overview",
      children: (
        <>
          <Insights entity={props.entity} />
        </>
      ),
    },
    props.history && {
      key: "history",
      id: "history",
      label: "History",
      children: <>{props.history}</>,
    },
  ].filter(Boolean) as TabsProps["items"];
}
